import { useOutletContext } from 'react-router-dom'

import { TrainingsTrainingFile } from 'generated/resources/datatable.graphql'

export const useTrainingFilesContext = () =>
  useOutletContext<{ trainingFiles: TrainingsTrainingFile[] }>()

export type TrainingFile = TrainingsTrainingFile
